import {flushSync} from 'react-dom';
import {ProtoBuf} from './ProtoBuf';
import {sendGoogleAdsEvent} from './GoogleAds/GoogleAds';
import {URLManager} from './URLManager';

declare var $: any;
declare var window: any;

export class BreachWatchScanB2B {
    public static instance: BreachWatchScanB2B;
    public static getInstance() {
        if (!BreachWatchScanB2B.instance) {
            BreachWatchScanB2B.instance = new BreachWatchScanB2B();
        }
        return BreachWatchScanB2B.instance;
    }

    pbService: ProtoBuf;

    email: string;
    hashedEmail: string;
    domain: string;

    /////////////////////////////////////////////////

    scan(email: string, callback: Function, errorCallback: Function) {
        // validate email and domain

        this.pbService = window.ProtoBufUtility;
        this.email = email.toLowerCase();
        this.domain = email.split('@')[1];

        let emailPromise = this.scanEmail();
        let domainPromise = this.scanDomain();

        Promise.all([emailPromise, domainPromise])
            .then(values => {
                callback({
                    ...(values[0] as object),
                    ...(values[1] as object),
                });
            })
            .catch(e => errorCallback(e));
    }

    /////////////////////////////////////////////////

    scanEmail() {
        return new Promise((resolve, reject) => {
            try {
                flushSync(() => {
                    this.hashedEmail = window.KeeperCrypto.breachwatch_hmac512(
                        'email:' + this.email
                    );

                    this.pbService.set({
                        request: window.BreachWatch.FreeScanRequest,
                        response: window.BreachWatch.FreeScanResponse,
                        api: window.API.ApiRequest,
                        apiPayload: window.API.ApiRequestPayload,
                    });
                });

                this.pbService.sendAsync(
                    window.keeperPreload.apiEndpoint + '/api/rest/breachwatch/free_scan',
                    () => {
                        /* */
                    },
                    {
                        hashedEmail: this.hashedEmail,
                    },
                    (success, response) => {
                        window.recaptchaToken = undefined;
                        if (success) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                );
            } catch (e) {
                console.error(e);
            }
        });
    }

    /////////////////////////////////////////////////

    scanDomain() {
        return new Promise((resolve, reject) => {
            try {
                let payload = {
                    domain: decodeURIComponent(this.domain),
                    email: decodeURIComponent(this.email),
                    utm_campaign: URLManager.getInstance().getParams()['utm_campaign'] || '',
                    utm_medium: URLManager.getInstance().getParams()['utm_medium'] || '',
                    utm_source: URLManager.getInstance().getParams()['utm_source'] || '',
                    utm_content: URLManager.getInstance().getParams()['utm_content'] || '',
                    device_type: URLManager.getInstance().getParams()['device_type'] || '',
                    ad_group: URLManager.getInstance().getParams()['ad_group'] || '',
                    ad_creative: URLManager.getInstance().getParams()['ad_creative'] || '',
                    leadSourceUrl:
                        URLManager.getInstance().getPageKey() + ' | (BreachWatchScanB2B)',
                    hubspot: {
                        portalID: '5481240',
                        formID: '822cef8d-244b-48a2-acb5-da47a2a71d3e',
                        context: {
                            hutk: '',
                            pageUri: window.location.href || '',
                            pageName: document.querySelector('title').text || '',
                        },
                    },
                };

                if (window.keeper.storage.isAvailable()) {
                    payload.hubspot.context.hutk = window.keeper.storage.getCookie('hubspotutk');
                }

                $.ajax({
                    method: 'POST',
                    type: 'POST',
                    url: window.keeperPreload.apiEndpoint + '/bi_api/v1/breachwatch/domain_lookup',
                    contentType: 'application/json',
                    dataType: 'json',
                    data: JSON.stringify(payload),
                    success: response => {
                        let res = response;
                        resolve(res);
                    },
                    error: response => {
                        let res = response;
                        reject(res);
                    },
                });
            } catch (e) {
                console.error(e);
            }
        });
    }

    /////////////////////////////////////////////////

    sendAnalytics() {
        if (window.hasGALoaded === true) {
            // Business_BreachWatch_Scan
            sendGoogleAdsEvent(window.keeper.gAdsMCCTag, '8JpvCNbhlo8ZEJ_B9_wC');
            sendGoogleAdsEvent(window.keeper.gAdsIndTag, 'rkbSCOabkZsZEJ63lvgD');
            sendGoogleAdsEvent(window.keeper.gAdsJapanTag, 'cV4yCNa_1-szEPOg8dso');
        }

        if (window.hasGTMLoaded === true) {
            window.dataLayer.push({
                event: 'Data-Breach-Scan-Complete-BW-B2B',
            });
            return;
        }
    }

    /////////////////////////////////////////////////

    tryParseJSON(json) {
        var json;

        try {
            json = JSON.parse(json);
            return json;
        } catch (e) {
            return '';
        }
    }
}

export default BreachWatchScanB2B;
